import script from "./ToolTip.vue?vue&type=script&lang=ts&setup=true"
export * from "./ToolTip.vue?vue&type=script&lang=ts&setup=true"

import "./ToolTip.vue?vue&type=style&index=0&id=a5294c2e&scoped=true&lang=scss"

import exportComponent from "/github/workspace/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a5294c2e"]])

export default __exports__